<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.exceptionName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.exceptionType" clearable placeholder="类型" style="width:120px">
        <el-option label="休息时间" value="01" />
        <el-option label="工作时间" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="exceptionName" label="名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="类型" width="100" align="center">
        <template slot-scope="{ row }">{{ row.exceptionType === '02' ? '工作时间' : '休息时间' }}</template>
      </el-table-column>
      <el-table-column prop="fromDate" label="开始" width="170" />
      <el-table-column prop="toDate" label="结束" width="170" />
      <el-table-column prop="shiftNames" label="班次" min-width="120" show-overflow-tooltip />
      <el-table-column prop="lineNames" label="产线" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="220" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.exceptionId)">修改</el-button>
          <el-button type="text" @click="openGenerate(row)">重复生成</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.exceptionId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.exceptionId ? '修改产线异常' : '新增产线异常'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="名称">
          <el-input v-model="form.exceptionName" placeholder="如：国庆放假" />
        </el-form-item>
        <el-form-item label="类型" prop="exceptionType">
          <el-radio-group v-model="form.exceptionType">
            <el-radio label="01">休息时间</el-radio>
            <el-radio label="02">工作时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开始时间" prop="fromDate">
          <el-date-picker v-model="form.fromDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="toDate">
          <el-date-picker v-model="form.toDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="关联班次">
          <el-select v-model="form.shiftIds" multiple filterable clearable style="width:100%" placeholder="可选">
            <el-option v-for="i in shiftOptions" :key="i.shiftId" :label="i.shiftName" :value="i.shiftId" />
          </el-select>
        </el-form-item>
        <el-form-item label="关联产线">
          <el-select v-model="form.lineIds" multiple filterable clearable style="width:100%" placeholder="可选">
            <el-option v-for="i in lineOptions" :key="i.lineId" :label="i.lineName" :value="i.lineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="跨日前夜班">
          <el-switch v-model="form.relatesToPrevDay" active-value="1" inactive-value="0" />
          <span style="margin-left:8px;color:#999;font-size:12px">异常日期与班次起始日不同时勾选</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="重复生成异常" :visible.sync="genVisible" width="480px" :close-on-click-modal="false">
      <el-form :model="genForm" label-width="100px">
        <el-form-item label="原异常">{{ genForm.exceptionName }}</el-form-item>
        <el-form-item label="重复类型">
          <el-select v-model="genForm.reproductionType" style="width:100%">
            <el-option label="每日" value="01everyDay" />
            <el-option label="每周" value="02everyWeek" />
            <el-option label="每月" value="03everyMonth" />
            <el-option label="每年" value="04everyYear" />
          </el-select>
        </el-form-item>
        <el-form-item label="截止日期">
          <el-date-picker v-model="genForm.reproductionToDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="genVisible = false">取消</el-button>
        <el-button type="primary" :loading="genSaving" @click="doGenerate">生成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listLineException, getLineException, saveLineException,
  updateLineException, deleteLineException, generateLineException
} from '../../api/lineException'
import { selectShift } from '../../api/shift'
import { selectProductionLine } from '../../api/productionLine'

function emptyForm() {
  return {
    exceptionId: '',
    exceptionName: '',
    exceptionType: '01',
    fromDate: '',
    toDate: '',
    shiftIds: [],
    lineIds: [],
    relatesToPrevDay: '0',
    remark: ''
  }
}

export default {
  name: 'MesLineExceptionPage',
  components: { ListPagination },
  data() {
    return {
      query: { exceptionName: '', exceptionType: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        exceptionType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        fromDate: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        toDate: [{ required: true, message: '请选择结束时间', trigger: 'change' }]
      },
      shiftOptions: [],
      lineOptions: [],
      genVisible: false,
      genSaving: false,
      genForm: {}
    }
  },
  created() {
    this.loadOptions()
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    loadOptions() {
      selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => {})
      selectProductionLine().then(res => { this.lineOptions = res.data || [] }).catch(() => {})
    },
    load() {
      this.loading = true
      listLineException({
        currentPage: this.page,
        pageSize: this.pageSize,
        exceptionName: this.query.exceptionName,
        exceptionType: this.query.exceptionType
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getLineException(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row, {
          shiftIds: row.shiftIds || [],
          lineIds: row.lineIds || []
        })
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.exceptionId ? updateLineException(this.form) : saveLineException(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    openGenerate(row) {
      this.genForm = {
        exceptionId: row.exceptionId,
        exceptionName: row.exceptionName,
        reproductionType: '01everyDay',
        reproductionToDate: ''
      }
      this.genVisible = true
    },
    doGenerate() {
      if (!this.genForm.reproductionToDate) {
        this.$message.warning('请选择截止日期')
        return
      }
      this.genSaving = true
      generateLineException(this.genForm).then(res => {
        const count = (res.data && res.data.count) || 0
        this.$message.success('已生成 ' + count + ' 条')
        this.genVisible = false
        this.load()
      }).finally(() => { this.genSaving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteLineException([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
